@if (showAgentIcon()) {
    <div (click)="openAIAgent()">
        <img [src]="agentIconSrc()" class="ai-agent-icon" />
    </div>
}

<app-chat-flyout #chatFlyout [(isOpen)]="showAIAgent" [headerText]="'Ecolab Virtual Assistant'" (onRightPanelToggle)="onToggleRightPanel($event)" (onWidthChange)="onFlyoutWidthChange($event)" [flyoutWidthPercent]="flyOutWidthPercentage()">
    <div panelHeader>
        <div class="new-chat-container" (click)="startNewChat()">
            <img src="../../../../assets/edit_square.svg" alt="New Chat" />
            <span class="new-chat-label">{{ 'AI_AGENT.NEW_CHAT' | translate }}</span>
        </div>

    </div>
    <div leftPanel class="col-12 chat-bot-container"> <!--*ngIf="contextPointId"-->
        <div class="chat-messages" #chatContainer>
            @if (contextPointId() && !isLoadingChat()) {
                <div class="messages-list">
                    @for (message of messages(); track trackByMessageId($index, message)) {
                        <div class="message-wrapper"
                            [class.user-message]="isUserMessage(message)" [class.bot-message]="isBotMessage(message)">
                            @if (isUserMessage(message)) {
                                <div class="message-bubble user-message-bubble">
                                    <div class="message-content message-content--user">
                                        @if (getUserMessagePrefixIconPath(message); as promptPrefixIconPath) {
                                            <img class="user-message-prefix-icon" [src]="promptPrefixIconPath" alt="" aria-hidden="true" />
                                        }
                                        <span>{{ message.content.data }}</span>
                                    </div>
                                </div>
                            }

                            <!-- Bot message rendered via eva-chat-content component -->
                            @if (isBotMessage(message)) {
                                <nalco-eva-chat-content
                                    [message]="message"
                                    [suggestions]="getEvaSuggestions(message)"
                                    [selectedFeedback]="getSelectedFeedback(message.id)"
                                    (suggestionSelected)="onChipSelection({ name: $event, value: $event, iconUrl: '' })"
                                    (likeClicked)="sendFeedback($event, true)"
                                    (dislikeClicked)="sendFeedback($event, false)">
                                </nalco-eva-chat-content>
                            }

                        </div>
                    }

                    <!-- Loading indicator -->
                    @if (isLoading) {
                        <div class="message-wrapper bot-message">
                            <div class="layered-icon" style="width: 50px;">
                                <img class="icon-background"
                                    src="../../../../assets/Ecolab-Virtual-Agent-Chat-Logo.svg"
                                    placement="left">
                            </div>
                            <div class="message-bubble loading">
                                <div class="message-header">
                                </div>

                                <div class="message-content">
                                    <div class="typing-indicator">
                                        <span class="typing-dot"></span>
                                        <span class="typing-dot"></span>
                                        <span class="typing-dot"></span>
                                    </div>
                                    <span class="typing-text">{{agentProcessingMessage}}</span>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            }
            @if (isLoadingChat()) {
                <div class="default-chat-loader">
                    <nalco-refresh-loader [isLoading]="isLoadingChat()"></nalco-refresh-loader>
                </div>
            }
        </div>

    </div>
    <div rightPanel>
        <app-chat-history-list #chatHistoryList [showAIAgent]="showAIAgent"
            (chatHistorySelected)="onChatHistorySelected($event)"></app-chat-history-list>
    </div>
    <div panelFooter class="panel-footer-input">
        <div class="chat-input-container">
            <div class="input-area">
                <div class="ask-eva-container">
                    <div class="input-box" (click)="editMessageId = null">
                        <textarea id="ask-label" class="input-text" [ngClass]="{'error': noInput}" rows="1"
                            [placeholder]="currentPlaceholder" [(ngModel)]="currentMessage"
                            (keydown)="onKeyPress($event)" (input)="onTextareaInput($event)">
                    </textarea>

                        <!-- Buttons positioned inside textarea -->
                        <div class="input-buttons">
                            <!-- Camera button -->
                            <button type="button" class="camera-btn" style="background: transparent !important; border: none !important; outline: none !important; box-shadow: none !important;" (click)="triggerImageUpload()" title="Upload image">
                                <svg xmlns="http://www.w3.org/2000/svg" width="19" height="17" viewBox="0 0 19 17" fill="none">
                                    <path d="M11.11 1.83333L12.7875 3.66667H16.5V14.6667H1.83333V3.66667H5.54583L7.22333 1.83333H11.11ZM11.9167 0H6.41667L4.73917 1.83333H1.83333C0.825 1.83333 0 2.65833 0 3.66667V14.6667C0 15.675 0.825 16.5 1.83333 16.5H16.5C17.5083 16.5 18.3333 15.675 18.3333 14.6667V3.66667C18.3333 2.65833 17.5083 1.83333 16.5 1.83333H13.5942L11.9167 0ZM9.16667 6.41667C10.6792 6.41667 11.9167 7.65417 11.9167 9.16667C11.9167 10.6792 10.6792 11.9167 9.16667 11.9167C7.65417 11.9167 6.41667 10.6792 6.41667 9.16667C6.41667 7.65417 7.65417 6.41667 9.16667 6.41667ZM9.16667 4.58333C6.63667 4.58333 4.58333 6.63667 4.58333 9.16667C4.58333 11.6967 6.63667 13.75 9.16667 13.75C11.6967 13.75 13.75 11.6967 13.75 9.16667C13.75 6.63667 11.6967 4.58333 9.16667 4.58333Z" fill="#ADAFAF"/>
                                </svg>
                            </button>

                            @if (voiceSupported) {
                                <button type="button" class="speech-btn"
                                    [ngClass]="{'active-recording': isRecording}" (click)="toggleRecording()"
                                    [title]="isRecording ? 'Click to stop recording' : 'Click to start recording'">
                                    <span class="mic-symbol" [class.pulsing]="isRecording">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="20" viewBox="0 0 14 20"
                                            fill="none">
                                            <path
                                                d="M7 12.7891C8.66 12.7891 10 11.4491 10 9.78906V3.78906C10 2.12906 8.66 0.789062 7 0.789062C5.34 0.789062 4 2.12906 4 3.78906V9.78906C4 11.4491 5.34 12.7891 7 12.7891ZM6 3.78906C6 3.23906 6.45 2.78906 7 2.78906C7.55 2.78906 8 3.23906 8 3.78906V9.78906C8 10.3391 7.55 10.7891 7 10.7891C6.45 10.7891 6 10.3391 6 9.78906V3.78906ZM12 9.78906C12 12.5491 9.76 14.7891 7 14.7891C4.24 14.7891 2 12.5491 2 9.78906H0C0 13.3191 2.61 16.2191 6 16.7091V19.7891H8V16.7091C11.39 16.2191 14 13.3191 14 9.78906H12Z"
                                                [attr.fill]="isRecording ? '#006BD3' : '#ADAFAF'"
                                                [attr.fill-opacity]="isRecording ? '1' : '0.65'" />
                                        </svg>
                                    </span>
                                </button>
                            }

                            <!-- Help button -->
                            <button type="button" class="help-btn" (click)="onHelpClick()"  style="background: transparent !important; border: none !important; outline: none !important; box-shadow: none !important;" title="Help">
                                <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
                                    <path d="M8.25 14.6667H10.0833V12.8333H8.25V14.6667ZM9.16667 0C4.10667 0 0 4.10667 0 9.16667C0 14.2267 4.10667 18.3333 9.16667 18.3333C14.2267 18.3333 18.3333 14.2267 18.3333 9.16667C18.3333 4.10667 14.2267 0 9.16667 0ZM9.16667 16.5C5.12417 16.5 1.83333 13.2092 1.83333 9.16667C1.83333 5.12417 5.12417 1.83333 9.16667 1.83333C13.2092 1.83333 16.5 5.12417 16.5 9.16667C16.5 13.2092 13.2092 16.5 9.16667 16.5ZM9.16667 3.66667C7.14083 3.66667 5.5 5.3075 5.5 7.33333H7.33333C7.33333 6.325 8.15833 5.5 9.16667 5.5C10.175 5.5 11 6.325 11 7.33333C11 9.16667 8.25 8.9375 8.25 11.9167H10.0833C10.0833 9.85417 12.8333 9.625 12.8333 7.33333C12.8333 5.3075 11.1925 3.66667 9.16667 3.66667Z" fill="#ADAFAF"/>
                                </svg>
                            </button>

                            <button class="send-btn" (click)="sendMessage()" title="Send query">
                                <svg xmlns="http://www.w3.org/2000/svg" width="19" height="17" viewBox="0 0 19 17"
                                    fill="none">
                                    <path
                                        d="M0 16.29V0.290039L19 8.29004L0 16.29ZM2 13.29L13.85 8.29004L2 3.29004V6.79004L8 8.29004L2 9.79004V13.29Z"
                                        fill="#006BD3" />
                                </svg>
                            </button>
                        </div>

                        <!-- Hidden file input -->
                        <input #imageInput type="file" accept="image/*" style="display: none;" (change)="onImageSelected($event)" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</app-chat-flyout>